import { render, staticRenderFns } from "./PaintTaskManage.vue?vue&type=template&id=4c6fda70&scoped=true"
import script from "./PaintTaskManage.vue?vue&type=script&lang=js"
export * from "./PaintTaskManage.vue?vue&type=script&lang=js"
import style0 from "./PaintTaskManage.vue?vue&type=style&index=0&id=4c6fda70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6fda70",
  null
  
)

export default component.exports